export default __webpack_public_path__ + "static/media/trailer_2_2.ca17cf9a.svg";